import React from "react";
import { connect } from "react-redux";
import { Jumbotron, Container } from "reactstrap";
import Logo from "../images/PGIMER_logo.png";
import { Col, Row } from "reactstrap";
import { colors } from "../Utils/Colors";

class Home extends React.Component {
  render() {
    return (
      <Container>
        <Row
          style={{
            //   border: "1px solid " + colors.lightGrey,
            borderBottom: "1px solid " + colors.lightGrey,
          }}
        >
          <Col style={{ textAlign: "left" }} sm={3}>
            <img style={{ maxWidth: 200 }} src={Logo} alt={"dr"} />
          </Col>
          <Col style={{ textAlign: "left" }} sm={6}>
            <h1 style={{ paddingTop: "8%", textAlign: "left" }}>
              Indian Rare Metabolic Bone Disorder Registry
            </h1>
          </Col>
          <Col style={{ textAlign: "left" }} sm={3} />
        </Row>
        <Jumbotron>
          <h1 className="display-3">Welcome {this.props.username}</h1>
          <br />
          <p>
            We are glad to see you logged in this panel.
            <br />
            To add details of a new patient, please click Add Patient.
            <br />
            To edit and view all types of personal and diagnostic details of
            patients, please click View Patients and then Edit Tests Data.
          </p>
          <br />
          <hr className="my-2" />
          <p>
            Department of Endocrinology
            <br />
            Postgraduate Institute of Medical Education &amp; Research
            <br />
            Chandigarh, India - 160012
          </p>
          <p className="lead"></p>
        </Jumbotron>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    username: state.user.username,
    isLoggedIn: state.user.isLoggedIn,
  };
};

export default connect(mapStateToProps)(Home);
